export default "__VITE_ASSET__DRuFJqEz__"